<template>
    <div class="modal-conventions">
        <div class="modal-conventions__content">
            <div class="modal-conventions__header">
                <b class="modal-conventions__title">
                    CONVENCIONES
                </b>
                <button
                    class="btn-close"
                    @click="Change_State_Conventions()"
                />
            </div>
            <div class="modal-conventions__body">
                <div
                    class="modal-conventions__section"
                    v-for="(item,index) in conventions"
                    :key="index"
                >
                    <span class="modal-conventions__section-title">
                        {{ item.title }}
                    </span>
                    <div
                        class="modal-conventions__section-icons"
                        v-for="(icon,i) in item.icons"
                        :key="i"
                    >
                        <img :src="icon.src">
                        <span>{{ icon.title }}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import conventionsJS from './conventions.js';
import {mapMutations} from 'vuex';

export default {
    name: 'ColaboratorsModal',

    data(){
        return {
            conventions: conventionsJS
        }
    },

    methods: {
        ...mapMutations('modals',['Change_State_Conventions'])
    }
}
</script>

<style scoped lang="scss">

.modal-conventions {
    align-items: center;
    background-color: $bg-dark-color-transparent;
    display: flex;
    height: 100%;
    justify-content: center;
    left: 0;
    position: absolute;
    top: 0;
    width: 100%;
    z-index: 3;

    &__content {
        background-color: $bg-light-color;
        height: 70%;
        width: 70%;
        padding: 1rem;
        border-radius: .3rem;
        box-shadow: inset .2em .2em 1em $custom-color;
    }

    &__header {
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
    }

    &__title {
        font-size: 2rem;
    }

    &__body {
        border-radius: .3rem;
        box-shadow: inset .2em .1em 1em $custom-color;
        display: flex;
        flex-wrap: wrap;
        height: 85%;
        overflow-y: auto;
    }

    &__section {
        display: flex;
        flex-wrap: wrap;
        width: 100%;

        &-title {
            font-weight: bold;
            margin: 1rem;
            width: 100%;
        }

        &-icons {
            align-items: initial;
            display: flex;
            flex-direction: column;
            flex-grow: 1;
            height: 8rem;
            margin: 1em 3rem;
            max-width: 6.5rem;
            min-width: 5rem;
            width: 5rem;

            img {
                width: 80%;
                height: auto;
                margin: 0 auto;
            }

            span {
                cursor: default;
                text-align: center;
                margin: auto;
                font-size: .8em;
            }
        }
    }
}

@media (max-width: 600px) {
    .modal-conventions  {
        &__title {
            font-size: 1.2em;
        }

        &__body {
            font-size: .8em;
        }

        &__section {
            justify-content: center;
        }
    }
}

@media (min-width: 1500px) {
    .modal-conventions {
        &__title {
            font-size: 1.2em;
        }

        &__section-icons {
            margin: 1.5em 4rem;
            height: 9rem;
            max-width: 8rem;
            min-width: 6.5rem;
            width: 7em;

            span {
                font-size: 1em;
            }
        }
    }
}
</style>